import {Hamburger} from './Hamburger';
import {TabLoop} from './TabLoop';
import {SlideAnimation} from './animations/SlideAnimation';

export class Menu {

    private static menus:Menu[]=[];

    constructor(private menu:JQuery<HTMLElement>) {
        let existing=Menu.menus.find(x=>x.menu.is(menu));
        if (existing) return existing;
        menu.on('hamburger.open', ()=>this.open());
        menu.on('hamburger.close', ()=>this.close());
        $(menu).find('.menu-close').on('click', ()=>{
            new Hamburger($('.hamburger')).close();
        });
        Menu.menus.push(this);

        $('.toggle-search').on( 'click', ()=>this.openSearchForm());
    }

    private openSearchForm() {
        let wrapper = $('.search-wrapper').toggleClass('search-open');
        let isOpen = wrapper.hasClass('search-open');

        $('.toggle-search')
            .attr('aria-expanded', String(isOpen))
            .attr('aria-label', isOpen ? 'Suche schließen' : 'Suche öffnen');

        let input = wrapper.find('input[name="search"]');
        let submit = wrapper.find('.submit-wrapper button');

        input.attr('tabindex', isOpen ? '0' : '-1');
        submit.attr('tabindex', isOpen ? '0' : '-1');

        if (isOpen) {
            input[0]?.focus();
        }
    }

    public async open() {
        let open = this.menu.hasClass('open');
        if(open) return;
        await new SlideAnimation(this.menu).from('left').to('center').play();
        this.menu.addClass('open');
        new TabLoop(this.menu.parent());
    }

    public async close() {
        let open = this.menu.hasClass('open');
        if(!open) return;
        new TabLoop(this.menu.parent()).destroy();
        await new SlideAnimation(this.menu).to('left').play();
        this.menu.removeClass('open');
    }

}

export {};